import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8">
            <div className="lg:col-span-2">
              <Link to="/" className="inline-flex items-center gap-2 mb-5">
                <span className="font-heading text-2xl font-bold text-primary-400 tracking-tight">
                  韩漫
                </span>
                <span className="font-heading text-lg text-background-300">
                  网站
                </span>
              </Link>
              <p className="text-sm text-background-400 mb-6 leading-relaxed max-w-sm">
                韩漫网站致力于为中文读者提供最新、最全的韩国漫画资源。我们精选海量优质韩漫，涵盖恋爱、奇幻、动作等多种类型，让每一位漫画爱好者都能找到心仪的作品。
              </p>
              <div className="flex items-center gap-3">
                {['ri-weibo-line', 'ri-wechat-line', 'ri-bilibili-line', 'ri-tiktok-line'].map((icon) => (
                  <a
                    key={icon}
                    href="#"
                    className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-600 text-background-300 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer"
                    aria-label="社交媒体"
                    rel="nofollow"
                  >
                    <i className={`${icon} text-base`}></i>
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">漫画分类</h4>
              <div className="flex flex-col gap-2.5">
                {categories.slice(0, 5).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">更多分类</h4>
              <div className="flex flex-col gap-2.5">
                {categories.slice(5).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">关于我们</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  品牌介绍
                </Link>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  联系我们
                </Link>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">
                  隐私政策
                </a>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">
                  服务条款
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2026 韩漫网站. 本站内容仅供学习交流，版权归原作者所有。
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap" rel="nofollow">
                服务条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}